import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerBalanceDetailHistoryCriteriaBean,
  CustomerBalanceDetailsRequest,
  CustomerSearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupInvoiceModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
class CustomerBalance extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer Balance Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new CustomerBalanceDetailHistoryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowSalesModule: false,
      moduleForPopup: [],
      inquiryData: null,
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      isDisableFields: false,
      alertMessage: [],
      order: "asc",
      sortField: "",
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadCustomerBalanceInquiryList(criteria);
  };
  loadCustomerBalanceInquiryList = (criteria) => {
    if (SecurityAccessManager.CustomerBalanceInquiry_IsAccessible()) {
      ReportService.inquireCustomerBalanceDetailsHistory(
        criteria,
        this.loadCustomerBalancePageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerBalancePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let inquiryDataList = response.data.result;
      if (inquiryDataList != null) {
        let customerBalanceDataList = [];
        if (
          response.data.result.historyInfos != null ||
          !isEmptyArray(response.data.result.historyInfos)
        ) {
          customerBalanceDataList = response.data.result.historyInfos;
          this.setState({
            isShowPDFButton: true,
            isShowExcelButton: true,
          });
        }
        this.setState({
          isInquiryDatasFound: true,
          isShowResetButton: true,
          inquiryDataList: customerBalanceDataList,
          inquiryData: inquiryDataList,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          isShowClearCriteriaButton: false,
        });
        this.disable();
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerBalanceDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerBalanceInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCustomerBalanceDetailsReport(
          listRequest,
          this.generateCustomerBalancePageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerBalanceInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerBalanceDetailsReport(
          listRequest,
          this.generateCustomerBalancePageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerBalancePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCustomerBalancePageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearError = () => {};
  clearCriteria = () => {
    let criteria = new CustomerBalanceDetailHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new CustomerBalanceDetailHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails("HistoryDate", "historyDate")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "OpeningBalance",
        "openingBalanceAmount"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Description", "description")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Invoice", "invoiceNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Amount", "transactionAmount")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Closing Balance",
        "closingBalanceAmount"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Remarks", "remarks")
    );
    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerCode = customerData.code;
        criteria.customerName = customerData.description;
        criteria.currencyCode = customerData.currencyCode;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerPageList != null &&
      response.data.customerPageList.customers != null
    ) {
      let customerData = response.data.customerPageList.customers;

      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  convertDescription = (value, list) => {
    if (value == 1) {
      return "New Invoice";
    }
    if (value == 2) {
      return "Invoice Cancel";
    }
    if (value == 3) {
      return "Invoice Update";
    }
    if (value == 4) {
      return "Invoice Return";
    }
    if (value == 5) {
      return "Invoice Unapproval";
    }
    if (value == 9) {
      return "Invoice Modify";
    }
    if (value == 11) {
      return "Check Payment , AR# " + list.documentNumber;
    }
    if (value == 12) {
      return "Credit Memo Apply, CM# " + list.documentNumber;
    }
    if (value == 6) {
      return "Credit Memo Approval, CM# " + list.documentNumber;
    }
    if (value == 8) {
      return "Credit Memo UnApproval, CM# " + list.documentNumber;
    }
    if (value == 13) {
      return "Credit Card Payment , AR# " + list.documentNumber;
    }
    if (value == 7) {
      return "Credit Memo Cancel , CM# " + list.documentNumber;
    }
    if (value == 14) {
      return "Debit Card Payment , AR# " + list.documentNumber;
    }
    if (value == 15) {
      return "Cash Payment , AR# " + list.documentNumber;
    }
    if (value == 16) {
      return "Charge back Apply , AR# " + list.documentNumber;
    }
  };
  convertAmount = (value, listValue) => {
    let returnvalue = parseFloat(value).toFixed(2);
    if (listValue == 1) {
      return this.color("[" + returnvalue + "]", listValue);
    }
    if (listValue == 2) {
      return this.color(returnvalue, listValue);
    }
  };
  color = (value, listvalue) => {
    if (listvalue == 1) {
      return <div class="purple">{value}</div>;
    }
    if (listvalue == 2) {
      return <div class="blue">{value}</div>;
    }
  };
  unAppliedCreditOnClick = (val) => {
    if (val <= 0) {
      let errMsg = "CreditMemo Details Not Found";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      //
    }
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let inquiryData = this.state.inquiryData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricLookupHandler={this.state.fabricLookupHandler}
          customerLookupHandler={this.state.customerLookupHandler}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
        />
        {this.state.isInquiryDatasFound && inquiryData != null && (
          <div>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>OpeningBalance</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  value={inquiryData.openingBalance}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                  onChange={this.onChange}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>ClosingBalance</FormLabel>
              </Col>

              <Col className="summary_text_box" sm="2">
                <NumberFormatInputbox
                  value={inquiryData.closingBalance}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                  onChange={this.onChange}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel
                  className="hyperLinkText"
                  // onClick={() =>
                  //   this.unAppliedCreditOnClick(
                  //     inquiryData.totalUnAppliedCreditMemoAmount
                  //   )
                  // }
                >
                  UnAppliedCredit MemoAmount
                </FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <NumberFormatInputbox
                  value={inquiryData.totalUnAppliedCreditMemoAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                  onChange={this.onChange}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Currency</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <InputTextbox
                  value={criteria.currencyCode}
                  className="summary_input text-right"
                  disabled={true}
                />
              </Col>
            </Row>
            <div className="div_default">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "historyDate")
                      }
                    >
                      HistoryDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "historyDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "openingBalanceAmount")
                      }
                    >
                      OpeningBalance
                      {this.state.order === "desc" &&
                      this.state.sortField === "openingBalanceAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th>Description</th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "invoiceNumber")
                      }
                    >
                      Invoice
                      {this.state.order === "desc" &&
                      this.state.sortField === "invoiceNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "transactionAmount")
                      }
                    >
                      Amount
                      {this.state.order === "desc" &&
                      this.state.sortField === "transactionAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "closingBalanceAmount")
                      }
                    >
                      ClosingBalance
                      {this.state.order === "desc" &&
                      this.state.sortField === "closingBalanceAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th onClick={(e) => this.handleSortingChange(e, "remarks")}>
                      Remarks
                      {this.state.order === "desc" &&
                      this.state.sortField === "remarks" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </tr>
                </thead>
                {inquiryDataList != null && (
                  <tbody>
                    {inquiryDataList.map((inquiryInfo, index) => (
                      <tr key={index}>
                        <td>{inquiryInfo.historyDate}</td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(
                            inquiryInfo.openingBalanceAmount
                          )}
                        </td>
                        <td>
                          {this.convertDescription(
                            inquiryInfo.transactionType,
                            inquiryInfo
                          )}
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewInvoiceModule(
                                e,
                                inquiryInfo.invoiceNumber
                              )
                            }
                          >
                            {inquiryInfo.invoiceNumber}
                          </Button>
                        </td>
                        <td className="text-right">
                          {this.convertAmount(
                            inquiryInfo.transactionAmount,
                            inquiryInfo.accountUpdateType
                          )}
                        </td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(
                            inquiryInfo.closingBalanceAmount
                          )}
                        </td>
                        <td>{inquiryInfo.remarks}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
              {inquiryDataList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let criteria = props.criteria;
  let isDisableFields = props.isDisableFields;
  let customerLookupHandler = props.customerLookupHandler;
  const customerCodeRef = props.customerCodeRef;
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>History Date-From</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="invoiceFromDate"
            value={criteria.invoiceFromDate}
            onChange={onChange}
            disabled={isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>History Date-To</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="invoiceToDate"
            onChange={onChange}
            value={criteria.invoiceToDate}
            disabled={isDisableFields}
          />
        </Col>
      </Row>
    </div>
  );
}
function CustomerBalanceInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerBalance {...props} name="" /> <br />
    </div>
  );
}

export default CustomerBalanceInquiry;
